<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.BookingReceiptLog')"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :style="{width:'100%',height:'450px'}"
      @gridReady="params=>gridApi=params.api"
    />
    <span slot="footer">
      <el-button @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { queryMessageLog } from '@/api/seaExport/seaExportJob'

export default {
  name: 'BookingSpaceLogDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: true }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_OperateBy'),
          field: 'userId',
          suppressMenu: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_Status'),
          field: 'state',
          suppressMenu: true,
          cellRenderer: (params) => {
            if (Number(params.value) === 1) {
              return this.$t('SeaExport.SentSuccessfully')
            } else {
              return this.$t('Message.SendFailed')
            }
          },
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_Time'),
          field: 'dateCreated',
          suppressMenu: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 200
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      if (!this.jobUuid) {
        this.$message.warning(this.$t('Message.BusinessCannotBeEmpty'))
        return
      }
      queryMessageLog(this.jobUuid).then(res => {
        this.rowData = res.data
      })
    }
  }
}
</script>

<style>
</style>
